import React from "react";
import Chart from "react-google-charts";
import { FormattedMessage, injectIntl } from "react-intl";
import SystemHelper from "../shared/systemHelper";
import { withRouter } from '../shared/hoc/withRouter';


class DonutChart2 extends React.Component {
  shouldComponentUpdate(nextProps, nextState) {
    if (this.props.data !== nextProps.data ||
      this.props.colors !== nextProps.colors
    ) {
      return true;
    }
    else {
      return false;
    }
  }

  render() {
    const { title, data, colors } = this.props;
    const total = data.reduce((previousVal, item) => { if (typeof item[1] === 'number') { return previousVal + item[1] } else { return previousVal } }, 0);

    return (

      <div  style={{ width:"100%", height:"100%", display: 'flex', alignItems: 'start', justifyContent: 'space-between' }}>

        {
          total === 0 && (
            <div style={{  width:"100%", height:"100%",minWidth: 220, minHeight: 220, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <span style={{ fontFamily: SystemHelper.getThemeTextFont(), fontSize: '1.1rem', color: '#74788d', textAlign: 'center' }}>{this.props.intl.formatMessage({ id: 'GENERAL.WARNING.NO_ITEM_AVAILABLE' }, { ITEM_NAME: title })}</span>
            </div>
          )
        }
        {
          total !== 0 && (
            <Chart
              width={'220px'}
              height={'220px'}
              chartType="PieChart"
              loader={<div>Loading Chart</div>}
              data={data}
              options={{
                legend: { position: 'bottom', textStyle: { fontSize: 10 } },
                title: total + ' ' + title,
                titleTextStyle: { color: '#74788d', fontName: SystemHelper.getThemeTextFont(), fontSize: 15, bold: false, fontWeight: '500' },
                tooltip: { text: 'value' },
                // Just add this option
                chartArea: { height: '80%', width: '100%', top: 25 },
                pieSliceText: 'value',
                pieSliceTextStyle: { color: '#74788', fontName: SystemHelper.getThemeTextFont(), fontSize: 15, bold: true, fontWeight: '500' },
                pieHole: 0.4,
                // is3D: true,
                colors: colors,
              }}
            />
          )
        }
        <a onClick={() => { this.props.navigate(this.props.viewURL); }} style={{ position: 'relative', top: '5px', textDecoration: 'underline', fontSize: '1.1rem' }}><FormattedMessage id="CONTRACT.DASHBOARD.VIEW_REGISTER" /></a>

      </div>


    )
  }
}

export default withRouter(injectIntl(DonutChart2));